var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky-cta-footer",style:(_vm.styles)},[(_vm.buttonProps)?_c('new-riseup-button',_vm._b({on:{"click":function($event){return _vm.$emit('click')}}},'new-riseup-button',_vm.buttonProps,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }